module.exports = __webpack_public_path__ + "static/media/icon-system-activity.72414645.svg";